import React, { useState } from 'react';
import {
  Box,
  Grid,
  TextField,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
} from '@mui/material';
import { Edit, Delete } from '@mui/icons-material';

export default function ItensNotaFiscalTab({ itens, setItens }) {
  // Índice do item que está sendo editado. -1 = nenhum
  const [editIndex, setEditIndex] = useState(-1);

  // Estado local do form de item
  const [itemForm, setItemForm] = useState({
    produto: '',
    lote: '',
    quantidade: '',
    valorUnitario: '',
    valorTotal: '',
  });

  // Quando muda algum campo do form de item
  const handleChangeForm = (field, value) => {
    setItemForm((prev) => ({ ...prev, [field]: value }));
  };

  // Adicionar ou atualizar item
  const handleAddOrUpdate = () => {
    // Validações simples
    if (!itemForm.produto) {
      alert('Produto é obrigatório!');
      return;
    }
    if (!itemForm.quantidade) {
      alert('Informe a quantidade!');
      return;
    }

    // Se editIndex >= 0, significa que estamos editando
    if (editIndex >= 0) {
      const newList = [...itens];
      newList[editIndex] = { ...itemForm };
      setItens(newList);
      setEditIndex(-1);
    } else {
      // Adicionando novo
      setItens([...itens, { ...itemForm }]);
    }

    // Limpa o form
    setItemForm({
      produto: '',
      lote: '',
      quantidade: '',
      valorUnitario: '',
      valorTotal: '',
    });
  };

  // Cancelar edição
  const handleCancelEdit = () => {
    setEditIndex(-1);
    setItemForm({
      produto: '',
      lote: '',
      quantidade: '',
      valorUnitario: '',
      valorTotal: '',
    });
  };

  // Editar item
  const handleEdit = (index) => {
    setEditIndex(index);
    setItemForm(itens[index]);
  };

  // Excluir item
  const handleDelete = (index) => {
    if (window.confirm('Deseja excluir este item?')) {
      setItens(itens.filter((_, i) => i !== index));
    }
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Itens da Nota
      </Typography>

      {/* Formulário para inserir/editar um item */}
      <Paper sx={{ p: 2, mb: 2 }}>
        <Grid container spacing={2}>
          {/* Produto */}
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="Produto"
              variant="outlined"
              fullWidth
              value={itemForm.produto}
              onChange={(e) => handleChangeForm('produto', e.target.value)}
            />
          </Grid>

          {/* Lote */}
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="Lote"
              variant="outlined"
              fullWidth
              value={itemForm.lote}
              onChange={(e) => handleChangeForm('lote', e.target.value)}
            />
          </Grid>

          {/* Quantidade */}
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="Quantidade"
              variant="outlined"
              fullWidth
              type="number"
              value={itemForm.quantidade}
              onChange={(e) => handleChangeForm('quantidade', e.target.value)}
            />
          </Grid>

          {/* Valor Unitário */}
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="Vlr Unitário"
              variant="outlined"
              fullWidth
              type="number"
              value={itemForm.valorUnitario}
              onChange={(e) => handleChangeForm('valorUnitario', e.target.value)}
            />
          </Grid>

          {/* Valor Total */}
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="Vlr Total"
              variant="outlined"
              fullWidth
              type="number"
              value={itemForm.valorTotal}
              onChange={(e) => handleChangeForm('valorTotal', e.target.value)}
            />
          </Grid>
        </Grid>

        <Box mt={2}>
          <Button
            variant="contained"
            onClick={handleAddOrUpdate}
            sx={{ mr: 2 }}
          >
            {editIndex >= 0 ? 'Atualizar Item' : 'Adicionar Item'}
          </Button>
          {editIndex >= 0 && (
            <Button variant="contained" color="error" onClick={handleCancelEdit}>
              Cancelar Edição
            </Button>
          )}
        </Box>
      </Paper>

      {/* Tabela dos itens */}
      <TableContainer component={Paper}>
        <Table>
          <TableHead sx={{ backgroundColor: '#f8f8f8' }}>
            <TableRow>
              <TableCell>Produto</TableCell>
              <TableCell>Lote</TableCell>
              <TableCell>Qtd</TableCell>
              <TableCell>Vlr Unit.</TableCell>
              <TableCell>Vlr Total</TableCell>
              <TableCell align="center">Editar</TableCell>
              <TableCell align="center">Excluir</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {itens.map((item, index) => (
              <TableRow key={index}>
                <TableCell>{item.produto}</TableCell>
                <TableCell>{item.lote}</TableCell>
                <TableCell>{item.quantidade}</TableCell>
                <TableCell>{item.valorUnitario}</TableCell>
                <TableCell>{item.valorTotal}</TableCell>
                <TableCell align="center">
                  <IconButton color="primary" onClick={() => handleEdit(index)}>
                    <Edit />
                  </IconButton>
                </TableCell>
                <TableCell align="center">
                  <IconButton color="error" onClick={() => handleDelete(index)}>
                    <Delete />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
            {itens.length === 0 && (
              <TableRow>
                <TableCell colSpan={7} align="center">
                  Nenhum item adicionado.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
